import { useState, useEffect, createContext, forwardRef, useContext } from "react";
import { useForm } from "react-hook-form";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { GridRowsProp, GridColDef } from '@mui/x-data-grid';
import { Box, Alert, Drawer, IconButton, Collapse, Button, Dialog, Slide, Chip, DialogTitle, DialogContent, DialogContentText, DialogActions, Tooltip, Popover } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import DataTableList from '../DataTableList';
import { checkPermission, axiosFunction, getSessionItem, clearSession } from '../../common';
import { PropertyForm } from "./PropertyForm";
import { PropertyView } from "./PropertyView";
import { PropertyContext } from "../../pages/Properties";
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Textsms } from '@mui/icons-material';
import { MessageDialog } from "../Modal/MessageDialog";
import QuotationForm from "../Jobs/QuotationForm";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

export const FormContext = createContext(null);
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const ManageProperties = ({ own }) => {
    const navigate = useNavigate(null);
    const comp = useLocation();
    let compseg = [comp.pathname.split('/')[2] ? comp.pathname.split('/')[2].replace('~', ' ') : ''];
    const { reset, handleSubmit, register, formState: { errors } } = useForm();
    const _role = getSessionItem("_role");
    const _is_landlord = getSessionItem("_is_landlord");
    const { setBackDropOpen } = useContext(PropertyContext);
    const [loader, setLoader] = useState(true);
    const [loaderText, setLoaderText] = useState(false);
    const [DTColumns, setDTColumns] = useState([]);
    const [alertStatus, setAlertStatus] = useState('success');
    const [alertOpen, setAlertOpen] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogViewOpen, setDialogViewOpen] = useState(false);
    const [confirmopen, setConfirmOpen] = useState(false);
    const [noteOpen, setNoteOpen] = useState(false);
    const [notes, setNotes] = useState('');
    const [delData, setDelData] = useState({});
    const [formChangeFlag, setFormChangeFlag] = useState(false);
    const [viewUpdateFlag, setViewUpdateFlag] = useState(false);
    const [userOptions, setUserOptions] = useState(null);
    const [postcodeOptions, setPostcodeOptions] = useState(null);
    const [lookUpsOptions, setLookUpsOptions] = useState(null);
    const [openForm, setOpenForm] = useState(false);
    const [propertyId, setPropertyId] = useState('');
    const [formField, setFormField] = useState({
        'property_id': '',
        'owner_id': '',
        'agent_id': '',
        'pfmgr_id': '',
        'tenancy_name': '',
        'tenancy_email': '',
        'tenancy_mobile': '',
        'agent_name': '',
        'agency_name': '',
        'address1': '',
        'address2': '',
        'suburb': '',
        'state': '',
        'postcode': '',
        'credit': '',
        'alertnote': '',
        'cc_email': '',
        'showalert': '',
        'service_duedate': '',
        'product_code': '',
        'is_under': '',
        'under_taken': '',
        'status': 'Y',
        'action': ''
    });
    const [searchFields, setSearchFields] = useState({
        "from_date": dayjs().startOf('month'),
        "to_date": dayjs().endOf('month')
    });
    const [currentVal, setCurrentVal] = useState({ product_code: '' });
    const [confirmSubmit, setConfirmSubmit] = useState(false);
    const [submitConfirmOpen, setSubmitConfirmOpen] = useState(false);
    const [openMessageDialog, setOpenMessageDialog] = useState(false);
    const [messageData, setMessageData] = useState({});
    const [updateTabList, setUpdateTabList] = useState(false);
    const [viewField, setViewField] = useState({
        'owner_id': '',
        'agent_id': '',
        'pfmgr_id': '',
        'tenancy_name': '',
        'tenancy_email': '',
        'tenancy_mobile': '',
        'owner_prefix': '',
        'owner_name': '',
        'owner_credit': 0,
        'agent_prefix': '',
        'agent_name': '',
        'agency_name': '',
        'owner_email': '',
        'owner_mobile': '',
        'owner_address1': '',
        'owner_address2': '',
        'owner_suburb': '',
        'owner_state': '',
        'owner_postcode': '',
        'agent_mobile': '',
        'address1': '',
        'address2': '',
        'suburb': '',
        'state': '',
        'postcode': '',
        'credit': '',
        'status': '',
        //'ag_mgr_id': '',
        'payments': {
            'overall': 0.00,
            'owner': {
                'overall': 0.00,
                'credit': 0.00
            }
        }
    });
    const [alertMessage, setAlertMessage] = useState('');
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [invItems, setInvItems] = useState({ items: [{ description: "", quantity: 1, charge: "", amount: "" }] });
    const [quotationFor, setQuotationFor] = useState({ owner_id: '', agent_id: '', property_id: '' });
    const [saveOption, setSaveOption] = useState('');
    const [servicesData, setServicesData] = useState(null);
    const [popAnchorEl, setPopAnchorEl] = useState(null);

    const popOpen = Boolean(popAnchorEl);
    const popId = popOpen ? 'simple-popover' : undefined;

    const popHandleClick = (event, item) => {
        setPopAnchorEl(event.currentTarget);
        setServicesData(item);
    };

    const popHandleClose = () => {
        setPopAnchorEl(null);
        setServicesData(null);
    };


    const fetchData = async (args) => {
        try {
            setBackDropOpen(true);
            var params = {}; //{ 'own': own }
            if (args) {
                params = args;
            }
            const propertyData = await axiosFunction('properties', 'get', params);
            if (propertyData.status === 'success') {
                setDTColumns(propertyData.data);
                setBackDropOpen(false);
                setLoader(false);
            } else {
                setAlertOpen(true);
                setAlertStatus('error');
                setAlertMessage(propertyData.message);
                setBackDropOpen(false);
                setLoader(false);
                /* if (propertyData?.response?.status === 401) {
                    clearSession();
                    navigate('/login');
                } */
            }
        } catch (e) {
            setAlertOpen(true);
            setAlertStatus('error');
            setAlertMessage(e.message);
            setBackDropOpen(false);
            setLoader(false);
            if (e?.response?.status === 401) {
                clearSession();
                navigate('/login');
            }
        }
    }

    const loadData = async () => {
        try {
            const lookUpsDataList = await axiosFunction('auth/lookups', 'get', {});
            const postCodeDataList = await axiosFunction('auth/postcodes', 'get', {});
            const userDataList = await axiosFunction('auth/users', 'post', {});
            if (lookUpsDataList.status === 'success') {
                setUserOptions(userDataList.data);
                setPostcodeOptions(postCodeDataList.data);
                setLookUpsOptions(lookUpsDataList.data);
                setOpenForm(true);
            } else {
                setAlertOpen(true);
                setAlertStatus('error');
                setAlertMessage(lookUpsDataList.message);
                setLoader(false);
                /* if (lookUpsDataList?.response?.status === 401) {
                    clearSession();
                    navigate('/login');
                } */
            }
        } catch (e) {
            setAlertOpen(true);
            setAlertStatus('error');
            setAlertMessage(e.message);
            setLoader(false);
            if (e?.response?.status === 401) {
                clearSession();
                navigate('/login');
            }
        }
    }

    useEffect(() => {
        if (!openForm) loadData();
        if (openForm && _role !== 'LDLORD') {
            fetchData({ from_date: dayjs().startOf('month').format('YYYY-MM-DD'), to_date: dayjs().endOf('month').format('YYYY-MM-DD'), own: own });

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openForm, own]);

    const viewServicesCheckStatus = (params, type) => {
        if (params.services && params.services.jobs && params.services.jobs.length > 0) {
            if (type === 'html') {
                return (<div className="d-flex">
                    {params.services.jobs.map((v, i) =>
                        <div key={'jobstatus-' + i} className={'job-status-lbl job-' + (['Non-Compliant', 'Safety Risk', 'UnSafe'].includes(v.declaration) ? 'unsafe' : ['Compliant', 'Safe'].includes(v.declaration) ? 'done' : 'pending') + (v.sa_count ? ' p-0' : '')}>
                            {v.service_type === 'ES' ? 'Elec' : v.service_type === 'GS' ? 'Gas' : v.service_type === 'SA' ? (v.sa_count ? v.sa_count + ' ' : '') + 'Smo' : v.service_type === 'OTH' ? 'Oth' : ''}
                        </div>
                    )}
                </div>);
            } else {
                let text = '';
                text += params.services.jobs.map((v, i) => {
                    return v.service_type === 'ES' ? 'Elec ' : v.service_type === 'GS' ? 'Gas ' : v.service_type === 'SA' ? (v.sa_count ? v.sa_count + ' ' : '') + 'Smo ' : v.service_type === 'OTH' ? 'Oth ' : ''
                });

                return text;
            }
        }
    }

    const viewJobStatus = (params, type) => {
        let j = 0;

        if (type === 'single') {
            params = params.row;
        }

        if (params.services && params.services.jobs && params.services.jobs.length > 0) {
            if (type === 'single') {
                for (let i = 0; i < params.services.jobs.length; i++) {
                    if (['Non-Compliant', 'Safety Risk', 'UnSafe'].includes(params.services.jobs[i].declaration)) {
                        j = i;
                        break;
                    }
                }
                if (params.services.jobs[j].declaration) {
                    if (type === 'multiple') {
                        return params.services.jobs[j].declaration === 'Compliant' ? params.services.jobs[j].declaration + 's' : params.services.jobs[j].declaration;
                    } else {
                        return <Button aria-describedby={params.id} endIcon={<ArrowDropDownIcon />} variant="outlined" color={['Non-Compliant', 'Safety Risk', 'UnSafe'].includes(params.services.jobs[j].declaration) ? "error" : "success"} onClick={(e) => popHandleClick(e, params)}>{params.services.jobs[j].declaration}</Button>
                    }
                }
            } else {
                var declaration = '';
                for (let i = 0; i < params.services.jobs.length; i++) {
                    declaration += (params.services.jobs[i].declaration === 'Compliant' ? params.services.jobs[i].declaration + 's' : params.services.jobs[j].declaration) + ' ';
                }
                return declaration;
            }
        }
        return '';

    }

    const handleSMS = (data, usrcode, viewFlag) => {
        if (viewFlag) {
            setMessageData({
                property_id: data.property_id,
                property_details: <><div>{`${(data.address1 ? data.address1 + ', ' : '')} ${(data.address2 ? data.address2 + ', ' : '')}`},</div><div>{`${data.suburb}, ${data.state} - ${data.postcode}`}</div></>,
                usr_code: usrcode,
                usr_id: usrcode === 'LDLORD' ? data.owner_id : usrcode === 'AGENT' ? data.agent_id : usrcode === 'ADMSTF' ? data.pfmgr_id : '',
                to: usrcode === 'LDLORD' ? data.owner_mobile : usrcode === 'AGENT' ? data.agent_mobile : usrcode === 'ADMSTF' ? data.pfmgr_name : data.tenancy_mobile,
                name: usrcode === 'LDLORD' ? data.owner_name : usrcode === 'AGENT' ? data.agent_name : usrcode === 'ADMSTF' ? data.pfmgr_mobile : data.tenancy_name,
                email: usrcode === 'LDLORD' ? data.owner_email : usrcode === 'AGENT' ? data.agent_email : usrcode === 'ADMSTF' ? data.pfmgr_email : data.tenancy_email
            });
        } else {
            setMessageData({
                property_id: data.id,
                property_details: <><div>{`${(data.address1 ? data.address1 + ', ' : '')} ${(data.address2 ? data.address2 + ', ' : '')}`}</div><div>{`${data.suburb}, ${data.state} - ${data.postcode}`}</div></>,
                usr_code: usrcode,
                usr_id: usrcode === 'LDLORD' ? data.owner.individualuser.id : usrcode === 'AGENT' ? data.agent.individualuser.id : usrcode === 'ADMSTF' ? data.pfmgr.individualuser.id : '',
                to: usrcode === 'LDLORD' ? data.owner.individualuser.mobile : usrcode === 'AGENT' ? data.agent.individualuser.mobile : usrcode === 'ADMSTF' ? data.pfmgr.individualuser.mobile : data.tenancy_mobile,
                name: usrcode === 'LDLORD' ? (data.owner ? data.owner.prefix + '. ' : '') + data.owner.fullname : usrcode === 'AGENT' ? (data.agent.prefix ? data.agent.prefix + '. ' : '') + data.agent.fullname : usrcode === 'ADMSTF' ? (data.pfmgr.prefix ? data.pfmgr.prefix + '. ' : '') + data.pfmgr.fullname : data.tenancy_name,
                email: usrcode === 'LDLORD' ? data.owner.individualuser.email : usrcode === 'AGENT' ? data.agent.individualuser.email : usrcode === 'ADMSTF' ? data.pfmgr.individualuser.email : data.tenancy_email
            });
        }
        setOpenMessageDialog(true);
    }

    const showRectificationStatus = (params) => {
        let colorVal = 'default';
        if (params.row.services && params.row.services.rectification) {
            if (params.row.services.rectification === 'Send Quote')
                colorVal = 'info';
            else if (params.row.services.rectification === 'Pending Payment')
                colorVal = 'warning';
            else if (['Cancelled', 'Rescheduled'].includes(params.row.services.rectification))
                colorVal = 'error';
            else if (['Approved', 'Completed', 'Paid'].includes(params.row.services.rectification))
                colorVal = 'success';
            else if (params.row.services.rectification === 'Pending for Assign Job')
                colorVal = 'secondary';
            else if (params.row.services.rectification === 'Job In Progress')
                colorVal = 'primary';

            return <Chip label={params.row.services.rectification} color={colorVal} size="small" variant="outlined" />
        }
    }

    const rows: GridRowsProp = DTColumns;
    const columns: GridColDef[] = [
        { field: 'sno', headerName: '#', width: 50, renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1 },
        {
            field: 'actions', headerName: 'Actions', width: 150, sortable: false, renderCell: (params) => {
                return (<>
                    {checkPermission('PROPERTY', 'view') && <Tooltip title="View Property" placement="top" arrow ><Button type="button" onClick={(e) => handleView(params.row)} style={{ minWidth: '24px' }}><i className="fa fa-eye"></i></Button></Tooltip>}
                    {checkPermission('PROPERTY', 'edit') && <Tooltip title="Edit Property" placement="top" arrow ><Button type="button" onClick={(e) => handleEdit(params.row)} style={{ minWidth: '24px' }}><i className="fa fa-edit"></i></Button></Tooltip>}
                    {checkPermission('PROPERTY', 'delete') && <Tooltip title="Delete Property" placement="top" arrow ><Button type="button" onClick={(e) => deleteRecord(params.row.id)} style={{ minWidth: '24px' }}><i className="fa fa-trash"></i></Button></Tooltip>}
                    {checkPermission('PROPERTY', 'notes') && params.row.showalert === 'Y' && <Tooltip title="View Alert" placement="top" arrow ><Button type="button" onClick={(e) => viewAlert(params.row.alertnote)} style={{ minWidth: '24px' }}><i className="fa fa-message"></i></Button></Tooltip>}
                    {checkPermission('JOB', 'quotation') && <Tooltip title="Add Quotation" placement="top" arrow >
                        <Button type="button" onClick={(e) => handleQuotation(params.row, 'add')} style={{ minWidth: '24px', color: 'blue' }}><i className="fa fa-file-invoice-dollar"></i>+</Button></Tooltip>}
                </>)
            }, hide: true
        },
        { field: 'status', headerName: 'Status', width: 100, renderCell: (params) => (params.row.status === 'Y') ? <Chip label="Active" color="success" size="small" /> : (params.row.status === 'P') ? <Chip label="Pending" color="secondary" size="small" /> : (params.row.status === 'R') ? <Chip label="Ready to assign" color="error" size="small" /> : <Chip label="Inactive" color="warning" size="small" />, valueGetter: (value) => (value.status === 'Y') ? 'Active' : (value.status === 'P') ? 'Pending' : 'Inactive' },
        { field: 'id', headerName: 'Property ID', width: 100, valueGetter: (value, row) => row.id },
        { field: 'product', headerName: 'Product', width: 180, renderCell: (params) => params.row.product.description, valueGetter: (value, row) => row.product.description },
        { field: 'service_duedate', headerName: 'Service Due Date', width: 130, type: 'date', valueFormatter: (value) => value ? dayjs(value.split('/').reverse().join('/')).format('DD/MM/YYYY') : '' },
        { field: 'job_status', headerName: 'Job Status', width: 180, renderCell: (params) => viewJobStatus(params, 'single'), valueGetter: (value, row) => viewJobStatus(row, 'multiple') },
        { field: 'rectification', headerName: 'Rectification Status', width: 180, renderCell: (params) => showRectificationStatus(params), valueGetter: (value, row) => row.services && row.services.rectification },
        { field: 'tracker', headerName: 'Tracker Check', width: 180, renderCell: (params) => viewServicesCheckStatus(params.row, 'html'), valueGetter: (value, row) => viewServicesCheckStatus(row, 'text') },
        { field: 'address', headerName: 'Address', width: 200, renderCell: (params) => ((params.row.address1 ? params.row.address1 + ', ' : '') + (params.row.address2 ? params.row.address2 + ', ' : '') + params.row.suburb + ', ' + params.row.state + ' - ' + params.row.postcode), valueGetter: (value, row) => row.address1 + ' ' + row.address2 + ' ' + row.suburb + ' ' + row.state + ' ' + row.postcode },
        { field: 'agent_id', headerName: 'Agent / Assigned PM', width: 280, renderCell: (params) => ((params.row.agent && params.row.agent.individualuser) ? <div>{params.row.agent.agency && <div>A: {params.row.agent.agency.fullname}</div>}<div>PM: {params.row.agent.prefix ? params.row.agent.prefix + '.' : ''} {params.row.agent.fullname}</div><div>E: {params.row.agent.individualuser.email}</div><div>M: {params.row.agent.individualuser.mobile} {params.row.agent.individualuser.mobile && checkPermission('PROPERTY', 'send') && <Link to='#' onClick={() => handleSMS(params.row, 'AGENT', false)}><Textsms color='error' /></Link>}</div></div> : ''), valueGetter: (value, row) => (row.agent && row.agent.individualuser) ? (row.agent.agency ? row.agent.agency.fullname : '') + ' ' + row.agent.fullname + ' ' + row.agent.individualuser.email + ' ' + row.agent.individualuser.mobile : '' },
        { field: 'pfmgr_id', headerName: 'Portfolio Manager', width: 280, renderCell: (params) => ((params.row.pfmgr && params.row.pfmgr.individualuser) ? <div><div>N: {params.row.pfmgr.fullname}</div><div>E: {params.row.pfmgr.individualuser.email}</div><div>M: {params.row.pfmgr.individualuser.mobile} {params.row.pfmgr.individualuser.mobile && checkPermission('PROPERTY', 'send') && <Link to='#' onClick={() => handleSMS(params.row, 'ADMSTF', false)}><Textsms color='error' /></Link>}</div></div> : ''), valueGetter: (value, row) => (row.pfmgr && row.pfmgr.individualuser) ? row.pfmgr.fullname + ' ' + row.pfmgr.individualuser.email + ' ' + row.pfmgr.individualuser.mobile : '' },
        { field: 'tenancy_name', headerName: 'Tenant', width: 280, renderCell: (params) => (<div><div>N: {params.row.tenancy_name}</div><div>E: {params.row.tenancy_email}</div><div>M: {params.row.tenancy_mobile} {params.row.tenancy_mobile && checkPermission('PROPERTY', 'send') && <Link to='#' onClick={() => handleSMS(params.row, 'TENANT', false)}><Textsms color='error' /></Link>}</div></div>), valueGetter: (value, row) => row.tenancy_name + ' ' + row.tenancy_email + ' ' + row.tenancy_mobile },
        { field: 'owner_id', headerName: 'Landlord', width: 280, renderCell: (params) => ((params.row.owner && params.row.owner.individualuser) ? <div><div>N: {params.row.owner.fullname}</div><div>E: {params.row.owner.individualuser.email}</div><div>M: {params.row.owner.individualuser.mobile} {params.row.owner.individualuser.mobile && checkPermission('PROPERTY', 'send') && <Link to='#' onClick={() => handleSMS(params.row, 'LDLORD', false)}><Textsms color='error' /></Link>}</div></div> : ''), valueGetter: (value, row) => (row.owner && row.owner.individualuser) ? row.owner.fullname + ' ' + row.owner.individualuser.email + ' ' + row.owner.individualuser.mobile : '' },
        { field: 'updated_at', headerName: 'Updated On', width: 130, type: 'date', valueFormatter: (value) => value ? value : '' },
        { field: 'created_at', headerName: 'Created On', width: 130, type: 'date', valueFormatter: (value) => value ? value : '' }

    ];

    const handleQuotation = (data, action) => {
        setFormField({ subtotal: 0, tax_rate: 0, total: 0, action: action });
        setQuotationFor({ owner_id: data.owner_id, agent_id: data.agent_id, property_id: data.id });
        setInvItems({ property: data, items: [{ description: '', quantity: 1, charge: '', amount: '' }] });
        setDrawerOpen(true);
    }

    const handleView = (data) => {
        setPropertyId(data.id);
        setLoaderText(false);
        setViewUpdateFlag(true);
        setViewField({
            'owner_id': data.owner_id,
            'owner_prefix': data.owner ? data.owner.prefix : '',
            'owner_name': data.owner ? data.owner.fullname : '',
            'owner_email': data.owner ? data.owner.individualuser.email : '',
            'owner_mobile': data.owner ? data.owner.individualuser.mobile : '',
            'owner_address1': data.owner ? data.owner.address1 : '',
            'owner_address2': data.owner ? data.owner.address2 : '',
            'owner_suburb': data.owner ? data.owner.suburb : '',
            'owner_state': data.owner ? data.owner.state : '',
            'owner_postcode': data.owner ? data.owner.postcode : '',
            'owner_credit': data.owner ? data.owner.credit : '',
            'agent_id': data.agent_id,
            'agent_prefix': data.agent ? data.agent.prefix : '',
            'tenancy_name': data.tenancy_name,
            'tenancy_email': data.tenancy_email,
            'tenancy_mobile': data.tenancy_mobile,
            'agent_name': data.agent ? (data.agent.fullname ? data.agent.fullname + ' ' : '') : '',
            'agency_name': data.agent ? data.agent.agency.fullname : '',
            'agent_mobile': data.agent && data.agent.individualuser ? data.agent.individualuser.mobile : '',
            'pfmgr_id': data.pfmgr_id,
            'pfmgr_prefix': data.pfmgr ? data.pfmgr.prefix : '',
            'pfmgr_name': data.pfmgr ? (data.pfmgr.fullname ? data.pfmgr.fullname + ' ' : '') : '',
            'pfmgr_mobile': data.pfmgr && data.pfmgr.individualuser ? data.pfmgr.individualuser.mobile : '',
            'address1': data.address1,
            'address2': data.address2,
            'suburb': data.suburb,
            'state': data.state,
            'postcode': data.postcode,
            'credit': data.credit,
            'product': data.product,
            'product_code': data.product_code,
            'is_under': data.is_under,
            'under_taken': data.under_taken,
            'status': data.status,
            'payments': data.payments,
            'action': 'view'
        });
        if (!dialogViewOpen) setDialogViewOpen(true);
    }

    const viewAlert = (notes) => {
        setNoteOpen(true);
        setNotes(notes);
    };

    const handleAdd = (data) => {
        setFormField({
            'property_id': '',
            'owner_id': (data.owner_id) ? data.owner_id : '',
            'owner_prefix': (data.owner_prefix) ? data.owner_prefix : '',
            'owner_name': (data.owner_name) ? data.owner_name : '',
            'owner_mobile': (data.owner_mobile) ? data.owner_mobile : '',
            'owner_address1': data.owner_address1 ? data.owner_address1 : '',
            'owner_address2': data.owner_address2 ? data.owner_address2 : '',
            'owner_suburb': data.owner_suburb ? data.owner_suburb : '',
            'owner_state': data.owner_state ? data.owner_state : '',
            'owner_postcode': data.owner_postcode ? data.owner_postcode : '',
            'agent_id': (data.agent_id) ? data.agent_id : '',
            'agent_prefix': (data.agent_prefix) ? data.agent_prefix : '',
            'tenancy_name': (data.tenancy_name) ? data.tenancy_name : '',
            'tenancy_email': data.tenancy_email ? data.tenancy_email : '',
            'tenancy_mobile': (data.tenancy_mobile) ? data.tenancy_mobile : '',
            'agent_name': (data.agent_name) ? data.agent_name : '',
            'agency_name': (data.agency_name) ? data.agency_name : '',
            'agent_mobile': (data.agent_mobile) ? data.agent_mobile : '',
            'pfmgr_id': '',
            'address1': '',
            'address2': '',
            'suburb': '',
            'state': '',
            'postcode': '',
            'credit': '',
            'alertnote': '',
            'cc_email': '',
            'showalert': '',
            'service_duedate': '',
            'picture': [],
            'product_code': '',
            'is_under': '',
            'under_taken': '',
            'status': 'Y',
            // 'ag_mgr_id': '',
            'action': 'add'
        });
        setDialogOpen(true);
    };

    /* const onRowClick = useCallback(
        (params) => handleEdit(params.row), []
    ); */

    const handleEdit = (data) => {
        setLoaderText(false);
        setFormField({
            'property_id': data.id,
            'owner_id': data.owner_id,
            'owner_prefix': data.owner ? data.owner.prefix : '',
            'owner_name': data.owner ? (data.owner.prefix ? data.owner.prefix + '. ' : '') + data.owner.fullname : '',
            'owner_email': data.owner ? data.owner.individualuser.email : '',
            'owner_mobile': data.owner ? data.owner.individualuser.mobile : '',
            'owner_address1': data.owner ? data.owner.address1 : '',
            'owner_address2': data.owner ? data.owner.address2 : '',
            'owner_suburb': data.owner ? data.owner.suburb : '',
            'owner_state': data.owner ? data.owner.state : '',
            'owner_postcode': data.owner ? data.owner.postcode : '',
            'agent_id': data.agent_id,
            'agent_prefix': data.agent ? data.agent.prefix : '',
            'tenancy_name': data.tenancy_name,
            'tenancy_email': data.tenancy_email,
            'tenancy_mobile': data.tenancy_mobile,
            'agent_name': data.agent ? (data.agent.prefix ? data.agent.prefix + '. ' : '') + (data.agent.fullname ? data.agent.fullname + ' ' : '') : '',
            'agency_name': data.agent ? data.agent.agency_name : '',
            'agent_mobile': data.agent && data.agent.individualuser ? data.agent.individualuser.mobile : '',
            'pfmgr_id': data.pfmgr_id,
            'address1': data.address1,
            'address2': data.address2,
            'suburb': data.suburb,
            'state': data.state,
            'postcode': data.postcode,
            'credit': data.credit,
            'alertnote': data.alertnote,
            'cc_email': data.cc_email,
            'service_duedate': (data.service_duedate && data.service_duedate !== 'Invalid Date') ? data.service_duedate.split('/').reverse().join('/') : '',
            'product_code': data.product_code,
            'is_under': data.is_under,
            'under_taken': data.under_taken,
            'showalert': data.showalert,
            'status': data.status,
            //'ag_mgr_id': data.ag_mgr_id,
            'action': 'edit'
        });

        setCurrentVal({ product_code: data.product_code });
        setFormChangeFlag(false);
        setDialogOpen(true);
    };

    const checkFormChange = () => {
        setFormChangeFlag(true);
    };

    const handleAutoClose = () => {
        window.scrollTo(0, 0);
        setTimeout(() => setAlertOpen(false), 5000);
    };

    const handleViewDialogClose = (_, refList) => {
        setDialogViewOpen(false);
        setPropertyId('');
        setViewField({
            'owner_id': '',
            'agent_id': '',
            'tenancy_name': '',
            'tenancy_email': '',
            'tenancy_mobile': '',
            'owner_prefix': '',
            'owner_name': '',
            'owner_credit': 0,
            'agent_prefix': '',
            'agent_name': '',
            'agency_name': '',
            'owner_email': '',
            'owner_mobile': '',
            'owner_address1': '',
            'owner_address2': '',
            'owner_suburb': '',
            'owner_state': '',
            'owner_postcode': '',
            'agent_mobile': '',
            'pfmgr_id': '',
            'pfmgr_name': '',
            'pfmgr_email': '',
            'pfmgr_mobile': '',
            'address1': '',
            'address2': '',
            'suburb': '',
            'state': '',
            'postcode': '',
            'credit': '',
            'status': '',
            // 'ag_mgr_id': '',
            'payments': {
                'overall': 0.00,
                'owner': {
                    'overall': 0.00,
                    'credit': 0.00
                }
            }
        });
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setFormField({
            'property_id': '',
            'owner_id': '',
            'agent_id': '',
            'tenancy_name': '',
            'tenancy_email': '',
            'tenancy_mobile': '',
            'agent_name': '',
            'agency_name': '',
            'pfmgr_id': '',
            'address1': '',
            'address2': '',
            'suburb': '',
            'state': '',
            'postcode': '',
            'credit': '',
            'alertnote': '',
            'cc_email': '',
            'showalert': '',
            'service_duedate': '',
            'picture': [],
            'product_code': '',
            'is_under': '',
            'under_taken': '',
            'status': '',
            //'ag_mgr_id': '',
            'action': '',
        });
        setQuotationFor({ owner_id: '', agent_id: '', property_id: '' });
        setSaveOption('');
        setDrawerOpen(false);
    };

    const deleteRecord = (id) => {
        var data = {
            "id": id,
            "_method": 'DELETE'
        }
        setDelData(data);
        setConfirmOpen(true);
    }

    const handleDelete = async () => {
        try {
            const delResponse = await axiosFunction('properties/' + delData.id, 'post', delData);
            setAlertOpen(true);
            if (delResponse.status === 'success') {
                setAlertStatus('success');
                setAlertMessage(delResponse.message);
                handleAutoClose();
                setConfirmOpen(false);
                setDelData({});
                fetchData();
            } else {
                setAlertStatus('error');
                setAlertMessage(delResponse.message);
                setConfirmOpen(false);
                setDelData({});
            }

        } catch (e) {
            setAlertStatus('error');
            setAlertMessage(e.message);
            setConfirmOpen(false);
            setDelData({});
            if (e?.response?.status === 401) {
                clearSession();
                navigate('/login');
            }
        }
    };

    const handleConfirmClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setConfirmOpen(false);
            setDelData({});
        }
    };

    const handleNoteClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setNoteOpen(false);
            setNotes('');
        }
    };

    const onSubmit = async (data) => {
        //console.log(data)
        setLoaderText(true);
        if (confirmSubmit || (currentVal.product_code && currentVal.product_code === formField.product_code) || formField.action === 'add') {
            setSubmitConfirmOpen(false);
            if (formField.action === 'add') {
                if (_role === 'AGENT' || _is_landlord === 'Y') {
                    data.status = 'P';
                } else {
                    data.status = checkPermission('JOB', 'edit') ? 'Y' : 'N';
                }
            }

            data.agent_id = formField.agent_id ? formField.agent_id : '';
            data.owner_id = formField.owner_id ? formField.owner_id : '';
            data.pfmgr_id = formField.pfmgr_id ? formField.pfmgr_id : '';
            //console.log(formField.service_duedate);
            data.credit = formField.credit;
            data.suburb = formField.suburb;
            data.state = formField.state;
            data.postcode = formField.postcode;
            data.service_duedate = formField.service_duedate;
            data.product_code = formField.product_code;
            if (!data.showalert) {
                data.showalert = formField.showalert === 'Y' ? 'Y' : 'N';
            }

            // console.log(data); 
            //console.log(formChangeFlag);
            // console.log(formField.property_id);

            if (formChangeFlag) {
                //console.log(formField.action);
                //console.log(data);
                try {
                    let saveResponse = null;
                    if (formField.action === 'edit') {
                        data._method = 'PUT';
                        saveResponse = await axiosFunction('properties/' + formField.property_id, 'post', data);
                    } else if (formField.action === 'add') {
                        saveResponse = await axiosFunction('properties', 'post', data);
                    }
                    setAlertOpen(true);
                    if (saveResponse.status === 'success') {
                        setAlertStatus('success');
                        setAlertMessage(saveResponse.message);
                        handleAutoClose();
                        handleDialogClose();
                        setViewUpdateFlag(own === 'Y' ? true : false);
                        setLoaderText(false);
                        onSearch();
                    } else {
                        setAlertStatus('error');
                        setAlertMessage(saveResponse.message);
                        setLoaderText(false);
                        document.querySelector('#propertyForm').scrollIntoView({ behavior: 'smooth' });
                        /* if (saveResponse?.response?.status === 401) {
                            clearSession();
                            navigate('/login');
                        } */
                    }
                } catch (e) {
                    setAlertStatus('error');
                    setAlertMessage(e.message);
                    setLoaderText(false);
                    document.querySelector('#propertyForm').scrollIntoView({ behavior: 'smooth' });
                    if (e?.response?.status === 401) {
                        clearSession();
                        navigate('/login');
                    }
                }
            } else {
                handleDialogClose();
                setViewUpdateFlag(true);
                setLoaderText(false);
                //setFormField((prev) => ({ ...prev, owner_id: data.owner_id }));
                //if(!dialogViewOpen) setDialogViewOpen(true);
            }
        } else if (!confirmSubmit) {
            setSubmitConfirmOpen(true);
            setLoaderText(false);
        } else {
            setLoaderText(false);
        }
    };

    /*  const handleImportOnChange = (e) => {
         const formData = new FormData();
         //console.log(e.target.files[0]);
         formData.append('file', e.target.files[0]);
         console.log(formData);
     
         const _token = getSessionItem("_token");
         axios.defaults.withCredentials = true;
         //axios.defaults.headers['Accept'] = 'application/json';
         axios.defaults.headers['Content-Type'] = 'multipart/form-data';
         if (_token) axios.defaults.headers['Authorization'] = 'Bearer ' + _token;
     
     
         axios.post(apiBaseUrl + "property/import", formData)
             .then(function (response) {
                 //handle success
                 console.log(response);
             })
             .catch(function (response) {
                 //handle error
                 console.log(response);
             });
     } */

    const onSearch = async () => {

        if (searchFields.from_date || searchFields.to_date || searchFields.technician_id || searchFields.job_status) {

            var params = {};
            if (searchFields.from_date) params.from_date = dayjs(searchFields.from_date).format('YYYY-MM-DD');
            if (searchFields.to_date) params.to_date = dayjs(searchFields.to_date).format('YYYY-MM-DD');

            fetchData(params);
        }
    }

    const handleSearchReset = () => {
        if (searchFields.from_date || searchFields.to_date || searchFields.technician_id || searchFields.job_status) {
            setSearchFields({
                "from_date": "",
                "to_date": ""
            });
            reset(searchFields);

            fetchData({});
        }
    }
    return (
        <>
            <Dialog
                fullScreen
                open={dialogOpen}
                onClose={handleDialogClose}
                TransitionComponent={Transition}
            >
                <FormContext.Provider value={
                    {
                        handleDialogClose,
                        onSubmit,
                        loaderText,
                        formField,
                        setFormField,
                        alertStatus,
                        alertMessage,
                        alertOpen,
                        setAlertOpen,
                        userOptions,
                        setUserOptions,
                        postcodeOptions,
                        lookUpsOptions,
                        propertyId,
                        checkFormChange,
                        openForm,
                        currentVal,
                        confirmSubmit,
                        setSubmitConfirmOpen,
                        submitConfirmOpen,
                        setConfirmSubmit
                    }
                }>
                    <PropertyForm own={own} />
                </FormContext.Provider>
            </Dialog>

            {own !== 'Y' ? (
                <>
                    <Collapse in={alertOpen}>
                        <Alert variant="filled" severity={alertStatus}
                            action={
                                <IconButton
                                    aria-label="close"
                                    color="inherit"
                                    size="small"
                                    onClick={() => {
                                        setAlertOpen(false);
                                    }}
                                >
                                    <CloseIcon fontSize="inherit" />
                                </IconButton>
                            }
                            sx={{ mb: 2, id: "alertmessage" }}
                        >
                            {alertMessage}
                        </Alert>
                    </Collapse>
                    <Dialog
                        open={confirmopen}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={handleConfirmClose}
                    >
                        <DialogTitle>Are you sure you want to delete this property?</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-description">
                                If yes, property will be deleted from the records and no longer be exists.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button className="themeholy-btn btn-secondary" onClick={handleConfirmClose}>Cancel</Button>
                            <Button className="themeholy-btn btn-primary" onClick={() => handleDelete({ delData })}>Yes</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        fullWidth
                        open={noteOpen}
                        TransitionComponent={Transition}
                        keepMounted
                        onClose={handleNoteClose}
                    >
                        <DialogTitle sx={{ bgcolor: '#000000', color: '#ffffff', marginBottom: '15px' }}>Notes</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-slide-notes">
                                <i className="fa fa-info-circle"></i> {notes}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button className="themeholy-btn btn-primary" onClick={handleNoteClose}>Ok</Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        fullScreen
                        open={dialogViewOpen}
                        onClose={handleViewDialogClose}
                        TransitionComponent={Transition}
                    >
                        <FormContext.Provider value={
                            {
                                handleViewDialogClose,
                                setLoaderText,
                                handleAdd,
                                handleEdit,
                                handleView,
                                viewField,
                                setViewField,
                                userOptions,
                                postcodeOptions,
                                propertyId,
                                setPropertyId,
                                viewUpdateFlag,
                                openForm,
                                updateTabList,
                                setUpdateTabList,
                                handleSMS
                            }
                        }>
                            <PropertyView own='N' />
                        </FormContext.Provider>
                    </Dialog>
                    {checkPermission('PROPERTY', 'search') &&
                        <Box component="form" id="job-search-form" name="job-search-form" noValidate autoComplete="off" onSubmit={handleSubmit(onSearch)} className="row">

                            <div className="col-12 col-md-6 d-flex">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label="Created/Updated From Date *"
                                        format="DD/MM/YYYY"
                                        name="from_date"
                                        {...register("from_date", { required: "From Date is required" })}
                                        maxDate={dayjs(searchFields.to_date ? searchFields.to_date : new Date(new Date().setMonth(new Date().getMonth() + 12)))}
                                        value={dayjs(searchFields?.from_date)}
                                        onChange={(newValue) => { setSearchFields((prev) => ({ ...prev, from_date: newValue })) }}
                                        sx={{ margin: '15px' }}
                                        slotProps={{
                                            textField: {
                                                error: errors.from_date ? true : false,
                                                helperText: errors.from_date?.message
                                            },
                                        }}
                                    />

                                    <DatePicker
                                        label="Created/Updated To Date *"
                                        format="DD/MM/YYYY"
                                        name="to_date"
                                        {...register("to_date", { required: "To Date is required" })}
                                        minDate={dayjs(searchFields.from_date)}
                                        maxDate={dayjs(new Date(new Date().setMonth(new Date().getMonth() + 12)))}
                                        value={dayjs(searchFields?.to_date)}
                                        onChange={(newValue) => { setSearchFields((prev) => ({ ...prev, to_date: newValue })) }}
                                        sx={{ margin: '15px' }}
                                        slotProps={{
                                            textField: {
                                                error: errors.to_date ? true : false,
                                                helperText: errors.to_date?.message,

                                            },
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="col-12 col-md-6 d-flex justify-content-start">
                                <Button type="submit" className="themeholy-btn btn-primary m-3" style={{ height: '50px' }} disabled={loaderText}>{(loaderText) ? 'Searching...' : 'Search'}</Button>
                                <Button type="button" className="themeholy-btn btn-secondary m-3" style={{ height: '50px' }} onClick={() => handleSearchReset()} >Reset</Button>
                            </div>
                        </Box>
                    }
                    {checkPermission('PROPERTY', 'add') &&
                        <div style={{ display: "flex", marginBottom: "15px" }}>
                            {/* <form>
                                <input type="file" name="file" accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" onChange={(e) => handleImportOnChange(e)} />

                            </form> */}
                            <Button type="button" className="themeholy-btn btn-primary" style={{ marginLeft: "auto" }} onClick={() => handleAdd({})}>Add {own === 'Y' ? 'My' : ''} New Property</Button>
                        </div>
                    }
                    {/* onRowClick={onRowClick} */}

                    <DataTableList columns={columns} rows={rows} loading={loader} columnVisibilityModel={{ actions: (checkPermission('PROPERTY', 'view') || checkPermission('PROPERTY', 'edit')) }} filterText={compseg} />

                    <Popover
                        id={popId}
                        open={popOpen}
                        anchorEl={popAnchorEl}
                        onClose={popHandleClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        sx={{
                            width: 400, // Adjust width here
                            '& .MuiPopover-paper': {
                                width: 400, // Ensure popover paper has the same width
                            },
                        }}
                    >
                        <div className="container-md text-left">
                            <div className="row row-cols-3 p-2 bg-smoke2">
                                <div className="col p-1 bg-theme2">Checks</div><div className="col p-1 bg-theme2">Status</div><div className="col p-1 bg-theme2">Next Due</div>
                            </div>
                            {servicesData && servicesData.services && servicesData.services.jobs && servicesData.services.jobs.map((v, i) => (
                                <div className="row row-cols-3 p-1 bg-smoke2" key={"serv_dtls_" + i}>
                                    <div className="col p-1">{v.service_type === 'ES' ? 'Electrical' : v.service_type === 'SA' ? 'Smoke' : v.service_type === 'GS' ? 'Gas' : 'Other'}</div>
                                    {['Non-Compliant', 'Safety Risk', 'UnSafe'].includes(v.declaration) ?
                                        <div className="col p-1" style={{ color: 'red' }}>{v.declaration}</div>
                                        :
                                        <div className="col p-1" style={{ color: 'green' }}>{v.declaration}</div>
                                    }
                                    <div className="col p-1">{v.service_type === 'SA' ? servicesData.sa_next_due_date : v.declaration ? servicesData.service_duedate : ''}</div>
                                </div>
                            ))}

                        </div></Popover>
                    {drawerOpen && <Drawer anchor="right" open={drawerOpen} sx={{ zIndex: 1400 }} PaperProps={{ className: 'container p-0' }}>
                        <QuotationForm
                            formField={formField}
                            setFormField={setFormField}
                            userOptions={null}
                            handleDialogClose={handleDialogClose}
                            saveOption={saveOption}
                            setSaveOption={setSaveOption}
                            quotationFor={quotationFor}
                            setQuotationFor={setQuotationFor}
                            invItems={invItems}
                            formChangeFlag={formChangeFlag}
                            setFormChangeFlag={setFormChangeFlag}
                            mainAlertStatus={setAlertStatus}
                            mainAlertOpen={setAlertOpen}
                            mainAlertMessage={setAlertMessage}
                            mainAlertAutoClose={handleAutoClose} />
                    </Drawer>}

                </>)

                : (
                    <FormContext.Provider value={
                        {
                            handleViewDialogClose,
                            setLoaderText,
                            handleAdd,
                            handleEdit,
                            handleView,
                            formField,
                            setFormField,
                            userOptions,
                            postcodeOptions,
                            propertyId,
                            setPropertyId,
                            viewField,
                            setViewField,
                            viewUpdateFlag,
                            openForm,
                            updateTabList,
                            setUpdateTabList,
                            handleSMS
                        }
                    }>
                        <PropertyView own={own} />
                    </FormContext.Provider>
                )}
            <MessageDialog openMessageDialog={openMessageDialog} messageData={messageData} setMessageData={setMessageData} setOpenMessageDialog={setOpenMessageDialog} setUpdateTabList={setUpdateTabList} />
        </>
    );
}
export default ManageProperties;